import { useCallback, useEffect, useState } from 'react';

import { useWalkthroughStore, WALKTHROUGH_STEPS } from '@core-ui/components';
import { useLocation } from 'react-router';

import type { SidebarMenuGroup } from './types';

export function useSidebar(menuGroups: SidebarMenuGroup[]) {
    const pathname = useLocation().pathname;
    const [activeGroupId, setActiveGroupId] = useState<string | null>(null);

    const { triggerWalkthrough: isWalkingThrough, currentStepIndex } =
        useWalkthroughStore();

    const onGroupSelect = useCallback((id: string) => {
        setActiveGroupId(id);
    }, []);

    useEffect(() => {
        if (isWalkingThrough) {
            const module = WALKTHROUGH_STEPS[currentStepIndex]?.module;
            setActiveGroupId(module ?? null);
        } else {
            if (activeGroupId) return;

            const group = menuGroups.find((group) => {
                if (group.to) {
                    return getExactUrl(group.to) === pathname.toLowerCase();
                }

                const submenuUrls = new Set(
                    group.children?.map((item) => getExactUrl(item.to)),
                );

                return submenuUrls.has(pathname.toLowerCase());
            });

            setActiveGroupId(group?.id ?? null);
        }
    }, [
        pathname,
        activeGroupId,
        menuGroups,
        isWalkingThrough,
        currentStepIndex,
    ]);

    return {
        activeGroupId,
        onGroupSelect,
    };
}

function getExactUrl(value: string) {
    return value.split('?')[0].toLowerCase();
}
